import React from "react";
import { BrowserRouter, Routes, Route, Link} from "react-router-dom";
import "./App.css";
import "./terms.css";
import { supabase } from "./lib/supabase";
import GKLogo from "./GK.png"
import ClientMessages from "./ClientMessages";

/* --------------------- Small icon helpers (inline SVG) --------------------- */
function Icon({ name }) {
  const common = {
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
  };

  const strokeProps = {
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };


  switch (name) {
    case "report":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M4 4h16v16H4z" />
          <path {...strokeProps} d="M8 16v-5" />
          <path {...strokeProps} d="M12 16v-8" />
          <path {...strokeProps} d="M16 16v-3" />
        </svg>
      );
    case "invoice":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M6 2h12v20l-2-1-2 1-2-1-2 1-2-1-2 1z" />
          <path {...strokeProps} d="M9 7h6" />
          <path {...strokeProps} d="M9 11h6" />
          <path {...strokeProps} d="M9 15h4" />
        </svg>
      );
    case "sync":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M21 12a9 9 0 0 0-15.5-6.4" />
          <path {...strokeProps} d="M3 4v6h6" />
          <path {...strokeProps} d="M3 12a9 9 0 0 0 15.5 6.4" />
          <path {...strokeProps} d="M21 20v-6h-6" />
        </svg>
      );
    case "calendar":
      return (
        <svg {...common}>
          <rect {...strokeProps} x="3" y="4" width="18" height="18" rx="2" />
          <path {...strokeProps} d="M16 2v4M8 2v4M3 10h18" />
        </svg>
  );
    case "messages":
      return (
        <svg {...common}>
          <path
            {...strokeProps}
            d="M21 15a4 4 0 0 1-4 4H8l-5 3V7a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4z"
          />
          <path {...strokeProps} d="M8 9h8" />
          <path {...strokeProps} d="M8 13h6" />
        </svg>
      );
    case "search":
      return (
        <svg {...common}>
          <circle {...strokeProps} cx="11" cy="11" r="7" />
          <path {...strokeProps} d="M20 20l-3.2-3.2" />
        </svg>
      );
    case "settings":
      return (
        <svg {...common}>
          <path
            {...strokeProps}
            d="M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"
          />
          <path
            {...strokeProps}
            d="M19.4 15a1.9 1.9 0 0 0 .4 2.1l.1.1-1.8 3.1-.2-.1a2 2 0 0 0-2.1-.1 2 2 0 0 0-1 1.8v.2H10.2v-.2a2 2 0 0 0-1-1.8 2 2 0 0 0-2.1.1l-.2.1-1.8-3.1.1-.1A1.9 1.9 0 0 0 4.6 15a2 2 0 0 0-1.6-1.1H2.8V10h.2a2 2 0 0 0 1.6-1.1 1.9 1.9 0 0 0-.4-2.1l-.1-.1L5.9 3.6l.2.1a2 2 0 0 0 2.1.1 2 2 0 0 0 1-1.8V1.8h3.6V2a2 2 0 0 0 1 1.8 2 2 0 0 0 2.1-.1l.2-.1 1.8 3.1-.1.1a1.9 1.9 0 0 0-.4 2.1A2 2 0 0 0 21.2 10h.2v3.8h-.2a2 2 0 0 0-1.6 1.2z"
          />
        </svg>
      );
    case "phone":
      return (
        <svg {...common}>
          <path {...strokeProps} d="M22 16.92v3a2 2 0 0 1-2.18 2A19.8 19.8 0 0 1 3.09 4.18 2 2 0 0 1 5.06 2h3a2 2 0 0 1 2 1.72c.12.9.32 1.77.59 2.6a2 2 0 0 1-.45 2.11L9.03 9.97a16 16 0 0 0 6 6l1.54-1.17a2 2 0 0 1 2.11-.45c.83.27 1.7.47 2.6.59A2 2 0 0 1 22 16.92z" />
        </svg>
  );
    case "shield":
      return (
        <svg {...common}>
          <path
            {...strokeProps}
            d="M12 2l8 4v6c0 5-3.5 9.5-8 10-4.5-.5-8-5-8-10V6l8-4z"
          />
          <path {...strokeProps} d="M9 12l2 2 4-5" />
        </svg>
      );
    default:
      return (
        <svg {...common}>
          <circle {...strokeProps} cx="12" cy="12" r="9" />
        </svg>
      );
  }
}

function IconBadge({ icon }) {
  return (
    <div className="icon-badge" aria-hidden="true">
      <Icon name={icon} />
    </div>
  );
}




/* --------------------- Home Page --------------------- */

function Home() {

  // STATE (inputs)
  const [missedCallsPerWeek, setMissedCallsPerWeek] = React.useState(12);
  const [bookingRate, setBookingRate] = React.useState(35);
  const [avgJobValue, setAvgJobValue] = React.useState(450);

  // CALCULATIONS
  const bookedJobs = missedCallsPerWeek * (bookingRate / 100);
  const weeklyRevenueLost = bookedJobs * avgJobValue;
  const monthlyRevenueLost = weeklyRevenueLost * 4.33;
  const yearlyRevenueLost = weeklyRevenueLost * 52;

  // FORMATTER
  const formatCurrency = (value) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 0,
    }).format(value);

  return (
    <div className="page">
      <header className="nav">
        <div className="container nav-inner">
          <Link className="brand" to="/">
            <span className="brand-text">
              <span className="brand-gk">GK </span>
              <span className="brand-tech">Technologies</span>
            </span>
          </Link>

          <nav className="nav-links">
            <a href="#services">Digital Hires</a>
            <a href="#process">How it works</a>
            <a href="#pricing">Pricing</a>
            <Link to="/contact">Get Started</Link>
          </nav>
        </div>
      </header>



      <section className="hero hero-dexian">
        <div className="container hero-grid">
          <div className="hero-copy">
            <div className="eyebrow">
              <span className="eyebrow-dot" />
              We build your AI workforce
            </div>

            <h1>
              Your Business Has Open Positions.{" "}
              <span className="accent">We Fill Them With Digital Employees.</span>
            </h1>

            <p className="lead">
              Stop losing leads to missed calls, slow follow-up, and routine admin work. We build Digital Hires that answer, follow up, schedule, route, and organize work your team should not have to chase.
              <br />
              <span className="underline">Hire them once. They work 24/7.</span>
            </p>

            <div className="cta-row">
              <Link className="btn btn-primary" to="/contact">
                Get started today →
              </Link>
              <a className="btn btn-ghost" href="#process">
                See how it works
              </a>
            </div>
          </div>
          <div className="hero-visual">
            <div className="digital-hire-card" aria-label="Digital hire roles">
              <div className="digital-hire-top">
                <span>The Model Employee</span>
              </div>
              <div className="digital-hire-list">
                <div className="digital-hire-track">
                  <span className="featured-hire">Receptionist: Missed-Call Text-Back</span>
                  <span>Lead Follow-Up Specialist</span>
                  <span>Sales Coordinator</span>
                  <span>Dispatch Assistant</span>
                  <span>Office Manager</span>
                  <span>Customer Support Rep</span>
                  <span>Bookkeeping Assistant</span>
                  <span>Appointment Scheduler</span>
                  <span className="featured-hire">Receptionist: Missed-Call Text-Back</span>
                  <span>Lead Follow-Up Specialist</span>
                  <span>Sales Coordinator</span>
                  <span>Dispatch Assistant</span>
                  <span>Office Manager</span>
                  <span>Customer Support Rep</span>
                  <span>Bookkeeping Assistant</span>
                  <span>Appointment Scheduler</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="automation-examples">

        <div className="container">
          <div className="section-head">
            <h2>Start With One Clear Business Problem</h2>
            <p>The easiest first Digital Hire is usually a Digital Receptionist that texts back missed calls, captures lead details, and gets the conversation moving.</p>
          </div>

          <div className="automation-grid">
            <div className="automation-tile automation-tile-featured">
              <h3>Digital Receptionist</h3>
              <p>Answers missed calls, collects details, replies fast, and sends the right next step before a lead goes cold.</p>
            </div>
            <div className="automation-tile">
              <h3>Digital Follow-Up Specialist</h3>
              <p>Checks in with old leads, open estimates, and past customers so good opportunities do not sit untouched.</p>
            </div>
            <div className="automation-tile">
              <h3>Custom Digital Hire</h3>
              <p>Need dispatching, sales support, customer service, bookkeeping, or admin help? We build the role around your workflow.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Full-width trust band (centered), separate from the sample brief card */}
      <div className="trust-band">
        <div className="container">
          <div className="trust-bar trust-bar--simple">
            <div className="trust-kicker">The Model Employee for the work your team should not have to chase.</div>
            <div className="trust-line">
             We audit your process, choose the best Digital Hire for the job, build the workflow, test the handoffs, and keep it focused on real business value.
            </div>
            <div className="cta-row cta-center">
              <Link className="btn btn-primary" to="/contact">
                Get Started →
              </Link>
              <a className="btn btn-ghost" href="#pricing">
                View pricing
              </a>
            </div>
          </div>
        </div>
      </div>

      <section className="features" id="services">
        <div className="container">
          <div className="section-head">
            <h2>What Your AI Workforce Can Handle</h2>
            <p>Practical Digital Hires for the parts of your business where speed, consistency, and follow-up matter most.</p>
          </div>

          <div className="feature-list">
            <article className="feature">
              <IconBadge icon="phone" />
              <h3>Customer Response</h3>
              <p>
                A Digital Receptionist can answer missed calls, reply to common questions, and follow up with leads, past customers, no-shows, and open estimates.
              </p>
            </article>

            <article className="feature">
              <IconBadge icon="report" />
              <h3>Data Automation And Reports</h3>
              <p>
                Your AI workforce can organize customer data, update records, summarize activity, and create simple reports your team can act on.
              </p>
            </article>

            <article className="feature">
              <IconBadge icon="settings" />
              <h3>Sales Support</h3>
              <p>
                A Digital Sales Coordinator can qualify interest, collect key details, and move ready buyers toward the next step.
              </p>
            </article>

            <article className="feature">
              <IconBadge icon="calendar" />
              <h3>Admin And Scheduling</h3>
              <p>
                A Digital Office Manager can help with reminders, summaries, scheduling links, internal alerts, and clean handoffs.
              </p>
            </article>
          </div>
        </div>
      </section>

    <section className="missed-call-calculator">
      <div className="calculator-card">
        <div className="calculator-header">
          <h2>See What One Automation Can Save You</h2>
          <p>
            Your Digital Receptionist can text back missed calls before a new lead moves on to another business.
          </p>
        </div>

        <div className="calculator-grid">
          <label>
            Missed calls per week
            <input
              type="number"
              min="0"
              value={missedCallsPerWeek}
              onChange={(e) => setMissedCallsPerWeek(Number(e.target.value) || 0)}
            />
          </label>

          <label>
            Estimated booking rate (%)
            <input
              type="number"
              min="0"
              max="100"
              value={bookingRate}
              onChange={(e) => setBookingRate(Number(e.target.value) || 0)}
            />
          </label>

          <label>
            Average customer value ($)
            <input
              type="number"
              min="0"
              value={avgJobValue}
              onChange={(e) => setAvgJobValue(Number(e.target.value) || 0)}
            />
          </label>
        </div>

        <div className="calculator-results">
          <div className="result-main">
            <span className="result-label">Estimated monthly revenue opportunity</span>
            <span className="result-value">
              {formatCurrency(monthlyRevenueLost)}
            </span>
          </div>

          <div className="result-subgrid">
            <div className="result-box">
              <span className="result-small-label">Potential bookings</span>
              <strong>{bookedJobs.toFixed(1)}</strong>
            </div>

            <div className="result-box">
              <span className="result-small-label">Estimated campaign revenue</span>
              <strong>{formatCurrency(weeklyRevenueLost)}</strong>
            </div>

            <div className="result-box">
              <span className="result-small-label">Annualized opportunity</span>
              <strong>{formatCurrency(yearlyRevenueLost)}</strong>
            </div>
          </div>

          <p className="calculator-note">
            This is why missed-call text-back is often the best first Digital Hire for a busy local business.
          </p>
          <p className="calculator-disclaimer">
          This calculator is provided for estimation purposes only and should not be considered financial or business advice.
          </p>
        </div>
      </div>
    </section>

      <section className="diagram" id="process">
        <div className="container">
          <div className="section-head">
            <h2>Built Around How You Already Work</h2>
            <p>
              We build Digital Hires around the way your business already handles leads, scheduling, customer communication, and operations.
            </p>
          </div>

          <div className="diagram-head">
            <div className="diagram-title">A Digital Hire designed to match your business</div>
            <div className="diagram-sub">
              Each setup is tailored to your tools, customers, response style, scheduling flow, and how you want important conversations handled.
            </div>
          </div>

          <div className="flow">
            <div className="flow-line" aria-hidden="true" />
            <div className="flow-pulse" aria-hidden="true" />

            <div className="flow-step">
              <div className="flow-badge blue">1</div>
              <div className="flow-card">
                <div className="flow-title">We find the open position</div>
                <div className="flow-tags">
                  <span className="flow-tag">Lead flow</span>
                  <span className="flow-tag">Scheduling</span>
                  <span className="flow-tag">Customer communication</span>
                </div>
              </div>
            </div>

            <div className="flow-step">
              <div className="flow-badge teal">2</div>
              <div className="flow-card">
                <div className="flow-title">We define the Digital Hire</div>
                <div className="flow-tags">
                  <span className="flow-tag">Automation logic</span>
                  <span className="flow-tag">Intent analysis</span>
                  <span className="flow-tag">Booking path</span>
                </div>
              </div>
            </div>

            <div className="flow-step">
              <div className="flow-badge green">3</div>
              <div className="flow-card">
                <div className="flow-title">We train it on your workflow</div>
                <div className="flow-tags">
                  <span className="flow-tag">Human tone</span>
                  <span className="flow-tag">Simple questions</span>
                  <span className="flow-tag">Business-specific</span>
                </div>
              </div>
            </div>

            <div className="flow-step">
              <div className="flow-badge blue">4</div>
              <div className="flow-card">
                <div className="flow-title">We launch, test, and improve</div>
                <div className="flow-tags">
                  <span className="flow-tag">Hands-off</span>
                  <span className="flow-tag">Clear handoffs</span>
                  <span className="flow-tag">Reliable workflow</span>
                </div>
              </div>
            </div>

            <div className="flow-footer flow-footer--full">
              <div className="flow-footer-title">
                Result: your business gets a practical Digital Hire that saves time, captures more opportunities, and supports the way your team already works.
              </div>
              <div className="flow-footer-tags">
                <span className="flow-pill">Fits your workflow</span>
                <span className="flow-pill">Less manual follow-up</span>
                <span className="flow-pill">More value from AI</span>
              </div>
            </div>
          </div>
        </div>
      </section>


<section className="pricing" id="pricing">
  <div className="container">
    <div className="section-head">
      <h2>Hire Your First Digital Employee</h2>
      <p>
        Most businesses start with missed-call text-back, then add more Digital Hires as the workflow proves itself.
      </p>
    </div>

    <div className="pricing-grid">

      <div className="price-card featured">
        <div className="price-top">
          <div className="price-pill">Best first hire</div>
          <div className="price-name">Digital Receptionist</div>
          <div className="price-desc">
            Missed-call text-back for businesses that need every new lead acknowledged right away.
          </div>
        </div>

        <ul className="price-bullets">
          <li>Texts back when a call is missed</li>
          <li>Collects the caller's name, need, and timing</li>
          <li>Routes urgent requests or sends booking links</li>
          <li>Built around your current phone workflow</li>
        </ul>

        <div className="price-nums">
          <div className="price-line">
            <span className="price-label">Monthly</span>
            <span className="price-val">$99</span>
          </div>
        </div>

        <div className="cta-row">
          <Link className="btn btn-primary" to="/contact">
            Get Started →
          </Link>
        </div>
      </div>

      <div className="price-card">
        <div className="price-top">
          <div className="price-name">Digital Follow-Up Specialist</div>
          <div className="price-desc">
            For businesses with old leads, past estimates, abandoned requests, or customers who need a timely check-in.
          </div>
        </div>

        <ul className="price-bullets">
          <li>Reaches out to old leads in controlled batches</li>
          <li>Uses simple, natural follow-up messages</li>
          <li>Sorts replies by interest and next step</li>
          <li>Helps ready leads book or reconnect</li>
        </ul>

        <div className="price-nums">
          <div className="price-line">
            <span className="price-label">Monthly</span>
            <span className="price-val">$149</span>
          </div>
        </div>

        <div className="cta-row">
          <Link className="btn btn-primary" to="/contact">
            Get Started →
          </Link>
        </div>
      </div>

      <div className="price-card">
        <div className="price-top">
          <div className="price-name">Custom Digital Hire</div>
          <div className="price-desc">
            For businesses that need a Digital Dispatcher, Sales Coordinator, Office Manager, CSR, Bookkeeper, or another custom AI role.
          </div>
        </div>

        <ul className="price-bullets">
          <li>Free AI workforce audit before we build</li>
          <li>Custom role design for your business process</li>
          <li>Automation for follow-up, routing, summaries, scheduling, or admin</li>
          <li>Launch support, testing, and refinement after setup</li>
        </ul>

        <div className="price-nums">
          <div className="price-line">
            <span className="price-label">Implementation</span>
            <span className="price-val">From $699</span>
          </div>
        </div>

        <div className="cta-row">
          <Link className="btn btn-primary" to="/contact">
            Get Started →
          </Link>
        </div>
      </div>

    </div>

    <div className="steps-container">
      <h3 className="price-name">What Happens Next</h3>
      <div className="steps-timeline">
        <div className="step">
          <div className="step-title">Quick Intro</div>
          <div className="step-desc">
            We review your business, current tools, lead flow, follow-up process, and the open positions a Digital Hire could fill.
          </div>
        </div>

        <div className="step">
          <div className="step-title">We Build The Hire</div>
          <div className="step-desc">
            We build the selected Digital Hire around your tools, message style, customer experience, and team handoff.
          </div>
        </div>

        <div className="step">
          <div className="step-title">Go Live</div>
          <div className="step-desc">
            Your Digital Hire goes live with testing, clear rules, and a simple handoff process for your team.
          </div>
        </div>

        <div className="step">
          <div className="step-title">You Get Measurable Value</div>
          <div className="step-desc">
            Your business saves time, responds faster, captures more opportunities, and keeps improving the workflow over time.
          </div>
        </div>
      </div>
    </div>

    <div className="pricing-note card" style={{ padding: 16, marginTop: 18 }}>
      <div className="muted">
        Start with a free AI workforce audit. We will show you which Digital Hire can create the most value before recommending an implementation.
      </div>
    </div>
  </div>
</section>

    <Footer />
    </div>
  );
}

/* --------------------- Footer --------------------- */

function Footer() {
  return (
    <footer className="footer">
      <div className="container footer-inner">
        <img
          src={GKLogo}
          alt="GK Technologies"
          className="footer-logo"
        />

        <p className="footer-text footer-text--center">
          © {new Date().getFullYear()} GK Technologies — By using our site, you
          agree to our <Link to="/terms">Terms of Service</Link>.
        </p>
      </div>
    </footer>
  );
}

/* --------------------- Contact Page --------------------- */

function Contact() {
  const [submitting, setSubmitting] = React.useState(false);
  const [message, setMessage] = React.useState("");

  const isSuccess = message && message.toLowerCase().startsWith("thanks");

  return (
    <div className="page">
      <header className="nav">
        <div className="container nav-inner">
          <Link className="brand" to="/">
            <span className="brand-mark">GK</span>
            <span className="brand-text">Technologies</span>
          </Link>

          <nav className="nav-links">
            <Link to="/">Home</Link>
            <a href="/#process">How it works</a>
            <a href="/#pricing">Pricing</a>
          </nav>
        </div>
      </header>

      <section className="contact">
        <div className="container">
          <div className="section-head">
            <h2>Get Your Free AI Workforce Audit</h2>
            <p>
              Tell us about your business, current tools, and the work your team keeps repeating.
              We’ll show you which Digital Hire makes the most sense and reply with next steps.
            </p>
          </div>

          <div className="contact-grid">
            <div className="card" style={{ padding: 18 }}>
              <h3 style={{ marginTop: 0 }}>What to include</h3>
              <div className="contact-list">
                <div>• Your name and business email</div>
                <div>• Your business name</div>
                <div>• The systems you currently use</div>
                <div>• Where follow-up, scheduling, customer service, or admin work slows you down</div>
                <div>• Which Digital Hire sounds most useful right now</div>
              </div>

              <div style={{ marginTop: 14 }}>
                <span className="muted">
                  We tailor each Digital Hire around your business process, existing tools, customer communication, and the outcomes you want improved.
                </span>
              </div>
            </div>

            <form
              className="card contact-form"
              onSubmit={async (e) => {
                e.preventDefault();
                const formEl = e.currentTarget;
                setMessage("");
                setSubmitting(true);

                const fd = new FormData(formEl);
                const payload = Object.fromEntries(fd.entries());

                if (!payload.name || !payload.email || !payload.brief) {
                  setMessage("Please fill in your name, email, and business details.");
                  setSubmitting(false);
                  return;
                }

                try {
                  const row = {
                    name: String(payload.name),
                    email: String(payload.email),
                    company: payload.company ? String(payload.company) : null,
                    niche: payload.niche ? String(payload.niche) : null,
                    phone_volume: payload.phone_volume ? String(payload.phone_volume) : null,
                    booking_system: payload.booking_system ? String(payload.booking_system) : null,
                    timeline: payload.timeline ? String(payload.timeline) : null,
                    brief: String(payload.brief),
                    request_type: "ai-workforce-audit",
                    source: "website-contact",
                  };

                  const { error } = await supabase.from("leads").insert(row);
                  if (error) throw error;

                  formEl.reset();
                  setMessage("Thanks! We’ll review your info and reply with next steps.");
                } catch (err) {
                  console.error(err);
                  setMessage("Sorry—something went wrong. Please try again.");
                } finally {
                  setSubmitting(false);
                }
              }}
            >
              <label>
                Name
                <input name="name" placeholder="Your name" required />
              </label>

              <label>
                Email
                <input name="email" type="email" placeholder="you@company.com" required />
              </label>

              <label>
                Business Name
                <input name="company" placeholder="Your business name" />
              </label>

              <label>
                Business Type
                <select name="niche" defaultValue="local-services">
                  <option value="local-services">Local Service Business</option>
                  <option value="med-spa">Med Spa / Aesthetic Business</option>
                  <option value="home-services">Home Services</option>
                  <option value="professional-services">Professional Services</option>
                  <option value="other">Other</option>
                </select>
              </label>

              <label>
                Current Lead Or Call Volume
                <select name="phone_volume" defaultValue="not-sure">
                  <option value="not-sure">Not sure</option>
                  <option value="1-5">Low volume</option>
                  <option value="6-15">Moderate volume</option>
                  <option value="16-plus">High volume</option>
                </select>
              </label>

              <label>
                Booking System
                <input
                  name="booking_system"
                  placeholder="Calendly, Jobber, Housecall Pro, Vagaro, none, etc."
                />
              </label>

              <label>
                When do you want to get started?
                <select name="timeline" defaultValue="this-week">
                  <option value="this-week">This week</option>
                  <option value="next-week">Next week</option>
                  <option value="this-month">This month</option>
                </select>
              </label>

              <label>
                Tell us about your current process
                <textarea
                  name="brief"
                  rows="5"
                  placeholder="What work would you like a Digital Hire to handle? Examples: missed calls, lead follow-up, scheduling, customer messages, summaries, dispatching, bookkeeping, or admin tasks."
                  required
                />
              </label>

              <button className="btn btn-primary" type="submit" disabled={submitting}>
                {submitting ? "Submitting…" : "Request AI Workforce Audit →"}
              </button>

              {message && (
                <p className={`form-message ${isSuccess ? "success" : "error"}`}>{message}</p>
              )}
            </form>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}


export default function App() {
  const Terms = React.lazy(() => import("./terms"));
  return (
    <BrowserRouter>
      <React.Suspense fallback={<div className="loading">Loading…</div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/client/:companyId/messages" element={<ClientMessages />} />
        </Routes>
      </React.Suspense>
    </BrowserRouter>
  );
}
